import { fetchAuthSession } from 'aws-amplify/auth';

export const API_BASE = 'https://clinixai.net';

// Calls the backend with the user's Cognito login token attached.
export async function apiFetch(path, options = {}) {
  const session = await fetchAuthSession();
  const token = session.tokens?.accessToken?.toString();
  const headers = { ...(options.headers || {}) };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return fetch(`${API_BASE}${path}`, { ...options, headers });
}

// Records an audit event (login, logout, copy_appeal). Never blocks the user.
export async function logEvent(action, appealId = null) {
  try {
    await apiFetch('/log-event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action, appeal_id: appealId }),
    });
  } catch (e) {
    // Logging failures should never interrupt the user.
  }
}
